import type { HomeReference, ProjectDetail } from './types';

export function ProjectMiniMap({ detail, referential }: { detail: ProjectDetail; referential: HomeReference }) {
  return (
    <div className="pcv3-wf-map">
      <img src={referential.snapshotUrl} width="100%" height="100%"
        alt={`Aperçu statique du contour et des bâtiments sélectionnés · ${detail.project.name}`}
        style={{ display: 'block' }} />
    </div>
  );
}
